import AppModel from '@/models/AppModel'
import store from '@/store/model-store'

const isDebug = process.env.NODE_ENV !== 'production'

export default {
  getApi: (bvModal, params = null, callbackSuccess = null, callbackFinally) => {
    return AppModel.get(
      'unit/list',
      bvModal,
      params,
      (res) => {
        if (isDebug) {
          console.log(res.data)
        }

        AppModel.validateStatus(res.data)

        if (callbackSuccess !== null) {
          callbackSuccess(res.data)
        }

        let modelStore = store.getters.model
        if (!modelStore) {
          modelStore = {}
        }
        modelStore['UnitListModel'] = res.data
        store.commit('setModel', modelStore)

        return Promise.resolve(res.data)
      },
      callbackFinally
    )
  },
  getStore: (key) => {
    return AppModel.getStore('UnitListModel', key)
  }
}



// WEBPACK FOOTER //
// ./src/models/UnitListModel.js